import React from 'react';
import { Card, CardContent, Box, Typography, Button, Divider } from '@mui/material';

export default function StartForm({ title, description, onBack, children }) {
  return (
    <Card elevation={2} sx={{ borderRadius: 3, overflow: 'visible', boxShadow: '0 6px 20px rgba(23,43,77,0.08)' }}>
      <Box sx={{
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        p: 2,
        background: 'linear-gradient(90deg, #2E7DFF 0%, #7C4DFF 100%)',
        color: '#fff'
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 800 }}>{title}</Typography>
            {description && (
              <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.95 }}>{description}</Typography>
            )}
          </Box>
          {onBack && (
            <Button variant="outlined" onClick={onBack} sx={{ textTransform: 'none', color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>
              Voltar
            </Button>
          )}
        </Box>
      </Box>

      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ '& .MuiTextField-root': { mb: 2 } }}>
          {children}
        </Box>
      </CardContent>
    </Card>
  );
}
